import React from 'react';
import { RequestGatewayModal } from './components/RequestGatewayModal';
import { gatewayRoleLabel } from './rolePolicy';

export interface CreateRequestEntryProps {
  isOpen: boolean;
  onClose: () => void;
  onBack?: () => void;
  /** Active role code (SYSTEM_OWNER, CLIENT, AUTHOR, …). */
  activeRole?: string;
  roleLabel?: string;
  /** Optional refresh hook after the hub closes (e.g. reload My Requests). */
  onSuccess?: () => void;
}

/**
 * ENTRY CONTRACT (Block 03 / U153):
 * Every allowed «+ Создать заявку» opens this single Create Request Hub.
 * No shortened forms, legacy request layers, or parallel modal flows.
 */
export const CreateRequestEntry: React.FC<CreateRequestEntryProps> = ({
  isOpen,
  onClose,
  onBack,
  activeRole = 'SYSTEM_OWNER',
  roleLabel,
  onSuccess,
}) => {
  const handleClose = () => {
    onSuccess?.();
    onClose();
  };

  return (
    <RequestGatewayModal
      isOpen={isOpen}
      onClose={handleClose}
      onBack={onBack ?? onClose}
      activeRole={activeRole}
      roleLabel={roleLabel ?? gatewayRoleLabel(activeRole)}
    />
  );
};
